module.exports = __webpack_public_path__ + "static/media/670.abf09216.webp";